module.exports = __webpack_public_path__ + "static/media/greenchip_small.90e79b82.svg";